var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", [_vm._v(_vm._s(_vm.header))]),
      _vm.type === "delegationTaskEquals"
        ? _c("v-select", {
            staticStyle: { width: "300px", display: "inline-block" },
            attrs: {
              label: _vm.$t("settings.workflow.delegationTaskEquals"),
              items: _vm.delegation_tasks,
              "item-text": "name",
              "item-value": "id",
              multiple: "",
              "small-chips": "",
              "deletable-chips": ""
            },
            model: {
              value: _vm.contextParams,
              callback: function($$v) {
                _vm.contextParams = $$v
              },
              expression: "contextParams"
            }
          })
        : _vm._e(),
      _vm.type === "delegationCostCentreEquals"
        ? _c("v-select", {
            staticStyle: { width: "300px", display: "inline-block" },
            attrs: {
              label: _vm.$t("settings.workflow.delegationCostCentreEquals"),
              "small-chips": "",
              multiple: "",
              "deletable-chips": "",
              items: _vm.cost_centres,
              "item-text": "name",
              "item-value": "id"
            },
            model: {
              value: _vm.contextParams,
              callback: function($$v) {
                _vm.contextParams = $$v
              },
              expression: "contextParams"
            }
          })
        : _vm._e(),
      _vm.type === "delegationOverallCostAbove"
        ? _c("amount-input", {
            staticStyle: { width: "300px", display: "inline-block" },
            attrs: {
              label: _vm.$t("settings.workflow.delegationOverallCostAbove"),
              rules: [
                function(v) {
                  return !!v || _vm.$t("global.required")
                }
              ],
              model: _vm.contextParams
            },
            on: {
              "update:model": function($event) {
                _vm.contextParams = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }